/* FLEXBOX HELPERS */
$displays: 'flex', 'inline-flex', 'block', 'inline', 'inline-block';
@each $display in $displays {
  .d-#{$display} {
    display: #{$display};
  }
}

$flexDirections: 'row', 'column', 'row-reverse', 'column-reverse';
@each $direction in $flexDirections {
  .flex-#{$direction} {
    flex-direction: #{$direction};
  }
}

$flexJustifyContent: 'start', 'end', 'center', 'space-between', 'space-around';
@each $justifyContent in $flexJustifyContent {
  .justify-#{$justifyContent} {
    justify-content: #{$justifyContent};
  }
}

$flexAlignItems: 'start', 'end', 'center', 'baseline', 'stretch';
@each $alignItems in $flexAlignItems {
  .align-items-#{$alignItems} {
    align-items: #{$alignItems};
  }
}

$flexAlignContent: 'start', 'end', 'center', 'between', 'around', 'stretch';
@each $alignContent in $flexAlignContent {
  .align-content-#{$alignContent} {
    align-content: #{$alignContent};
  }
}

.flex-auto {
  flex: auto;
}

$size: '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10';

// Flex helpers
@each $flex in $size {
  .flex-#{$flex} {
    flex: #{$flex};
  }
}

@each $flex in $size {
  .flex-shrink-#{$flex} {
    flex-shrink: #{$flex};
  }
}

@each $flex in $size {
  .flex-grow-#{$flex} {
    flex-grow: #{$flex};
  }
}

@each $flex in $size {
  .flex-basis-#{$flex} {
    flex-basis: #{$flex};
  }
}
